export class EmployeeViewModel {
    employeeId: string;
    employeeName: string;
    employeeFirstName: string;
    employeeLastName: string;

    constructor(model: any = {}) {
        this.employeeId = model.employeeId;
        this.employeeName = model.employeeName;
        this.employeeFirstName = model.employeeFirstName;
        this.employeeLastName = model.employeeLastName;
    }
}